// extracted by mini-css-extract-plugin
module.exports = {"speaker":"EventCardSpeaker_speaker__2tcVW","speakerAvatar":"EventCardSpeaker_speakerAvatar__1mOpe","speakerRole":"EventCardSpeaker_speakerRole__23Ypr"};